import {
	BagBankAccountsResponse,
	BagCurrenciesResponse,
	BagPaymentAmountResponse,
	BagPaymentBankAccount,
	BagPaymentCurrency,
	BagPaymentKind,
	BagPaymentKindsResponse,
	BagPaymentResponse,
	BagProfileDataResponse,
} from '@/bag/bag-payment-list/bag-payment-list.model';
import { UserData } from '@/reservation/reservation.model';
import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class BagPaymentListApiService {
	private readonly httpClient = inject(HttpClient);
	private readonly apiUrl = environment.apiUrl;

	getBankAccounts(queryParams: string): Observable<BagPaymentBankAccount[]> {
		return this.httpClient
			.get<BagBankAccountsResponse>(`${this.apiUrl}/bank_account/${queryParams}`)
			.pipe(map((result) => result.results));
	}

	getPaymentKinds(queryParams: string): Observable<BagPaymentKind[]> {
		return this.httpClient
			.get<BagPaymentKindsResponse>(`${this.apiUrl}/payment/kind/${queryParams}`)
			.pipe(map((result) => result.results));
	}

	getCurrencies(queryParams: string): Observable<BagPaymentCurrency[]> {
		return this.httpClient
			.get<BagCurrenciesResponse>(`${this.apiUrl}/currency/${queryParams}`)
			.pipe(map((result) => result.results));
	}

	getProfileData(queryParams: string): Observable<UserData[]> {
		return this.httpClient
			.get<BagProfileDataResponse>(`${this.apiUrl}/profile/data_full/${queryParams}`)
			.pipe(map((result) => result.results));
	}

	getPayments(params: string): Observable<BagPaymentResponse> {
		return this.httpClient.get<BagPaymentResponse>(`${this.apiUrl}/reservation/payment/?${params}`);
	}

	getPaymentsAmount(params: string): Observable<BagPaymentAmountResponse> {
		return this.httpClient.get<BagPaymentAmountResponse>(`${this.apiUrl}/reservation/payment/amount/?${params}`);
	}

	getPaymentsCsv(params: string): Observable<Blob> {
		return this.httpClient.get(`${this.apiUrl}/reservation/payment/csv/?${params}`, {
			responseType: 'blob',
		});
	}
}
